export const DEFAULT_GROUP_ID = 'clientList';

export const STANLEY_GROUP_ID = 'stanleyMatches';

export const SA_MATCHES_GROUP_ID = 'matchedClients';

export const STANLEY_ELIGIBLE_GROUP_ID = 'stanleyEligible';

export const NMVIP_GROUP_TYPE = 'NMVIP';

export const CLIENT_LIST_GROUP_TYPE = 'Client List';

export const BG_CONCIERGE_GROUP = 'bgConcierge';

export const DEFAULT_GROUP_DATA = {
  groupId: 'clientList',
  name: 'Client List',
  description: null,
  coverImageUrl: '',
  clientsCount: 0,
  averageAnnualAmount: 0,
  isDefault: true,
};

export const SA_MATCHES_GROUP_DATA = {
  averageAnnualAmount: 0,
  clientsCount: 0,
  coverColor: '#8B7024',
  defaultGroup: true,
  isDefault: true,
  description: 'Matched Clients',
  groupId: SA_MATCHES_GROUP_ID,
  name: 'Matched Clients',
  newMatchedClients: 0,
  yearPurchasesAmount: 0,
};

export const STANLEY_ELIGIBLE_GROUP_DATA = {
  averageAnnualAmount: 0,
  clientsCount: 0,
  coverColor: '#999999',
  defaultGroup: true,
  isDefault: true,
  description: 'Stanley Eligible',
  groupId: 'stanleyEligible',
  name: 'Stanley Eligible',
  yearPurchasesAmount: 0,
};

export const EMAIL_RECIPIENTS_LIMIT = 20;

export const GROUPS_SORT_BY = [
  {
    value: 'dateAsc',
    name: 'Oldest First',
  },
  {
    value: 'dateDesc',
    name: 'Newest First',
  },
  {
    value: 'alphabet',
    name: 'A to Z',
  },
  {
    value: 'clientsDesc',
    name: 'Clients: Most to least',
  },
  {
    value: 'clientsAsc',
    name: 'Clients: Least to most',
  },
];

export const SUPERUSER_AD_GROUP = 'G_OSP_SUPERUSER';
export const DIGITAL_STYLIST_AD_GROUP = 'G_OSP_NM_DIGITAL_STYLIST';
export const DIGITAL_STYLIST_AD_GROUP_TEST = 'G_OSP_DigitalStylist_TEST';
export const DIGITAL_CLIENT_ADVISOR_AD_GROUP = 'G_OSP_NM_DIGITAL_CLIENT_ADVISOR';

export const AD_GROUP_LIST = [
  { name: 'G_OSP_NM_STORE_MANAGER', label: 'Store Manager', brand: 'NM' },
  { name: 'G_OSP_NM_DIGITAL_STYLIST', label: 'Digital Stylist', brand: 'NM' },
  { name: 'G_OSP_NM_STYLIST_MANAGER', label: 'Stylist Manager', brand: 'NM' },
  { name: 'G_OSP_NM_STORE_ASSOCIATE', label: 'Store Associate', brand: 'NM' },
  { name: 'G_OSP_NM_DIGITAL_ClIENT_ADVISOR', label: 'Digital Client Advisor', brand: 'NM' },
  { name: 'G_OSP_NM_STORE_GENERAL_MANAGER', label: 'General Manager', brand: 'NM' },
  { name: 'G_OSP_BG_STORE_ASSOCIATE', label: 'Store Associate', brand: 'BG' },
  { name: 'G_OSP_BG_STORE_GENERAL_MANAGER', label: 'General Manager', brand: 'BG' },
  { name: 'G_OSP_BG_STORE_MANAGER', label: 'Store Manager', brand: 'BG' },
  { name: 'G_OSP_BG_INSTORE_SALES', label: 'Instore Sales', brand: 'BG' }, 
  { name: 'G_OSP_NM_BOH', label: 'Back of House', brand: 'NM' },
  { name: 'G_OSP_BG_BOH', label: 'Back of House', brand: 'BG' },

  // Test AD groups
  { name: 'G_OSP_NM_STORE_ASSOCIATE_TEST', label: 'Store Associate Test', brand: 'NM' },
  { name: 'G_OSP_NM_STORE_MANAGER_TEST', label: 'Store Manager Test', brand: 'NM' },
  { name: 'G_OSP_DigitalStylist_TEST', label: 'Digital Stylist Test', brand: 'NM' },
  { name: 'G_OSP_NM_STYLIST_MANAGER_TEST', label: 'Stylist Manager Test', brand: 'NM' },
  { name: 'G_OSP_BG_STORE_ASSOCIATE_TEST', label: 'Store Associate Test', brand: 'BG' },
  { name: 'G_OSP_BG_STORE_MANAGER_TEST', label: 'Store Manager Test', brand: 'BG' },
  { name: 'G_OSP_BG_STORE_GENERAL_MANAGER_TEST', label: 'Store General Manager Test', brand: 'BG' },
  { name: 'G_OSP_BG_INSTORE_SALES_TEST', label: 'Instore Sales Test', brand: 'BG' },
  { name: 'G_OSP_NM_BOH_TEST', label: 'Back of House', brand: 'NM' },
  { name: 'G_OSP_BG_BOH_TEST', label: 'Back of House', brand: 'BG' },
];
